import { render, staticRenderFns } from "./JdsPageBackLink.vue?vue&type=template&id=83e8f4d0&scoped=true&"
import script from "./JdsPageBackLink.vue?vue&type=script&lang=ts&"
export * from "./JdsPageBackLink.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPageBackLink.vue?vue&type=style&index=0&id=83e8f4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e8f4d0",
  null
  
)

export default component.exports